import { useRecommendedContext } from "../../context/recommended/RecommendedContext";
import Grid2 from "@mui/material/Unstable_Grid2";
import RecommendedAddSetting from "./RecommendedAddSetting";
import { RecommendedHeaderName } from "../../components/tableHeaderNames/HeaderName";
import RecommendedForm from "./RecommendedForm";
import Table from "../../components/table/Table";
import ThreeDotsLoading from "../../components/loader/ThreeDotsLoading";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Recommended = () => {
  const { tableData, config } = useRecommendedContext();
  const navigate = useNavigate();
  const hasData = config?.data?.config_list?.length;

  useEffect(() => {
    if (hasData === 0) {
      navigate("setting");
    }
  }, [hasData, navigate]);

  if (hasData === undefined) {
    return <ThreeDotsLoading bgWidth="100%" bgHeight="90vh" size={10} />;
  }

  return (
    <Grid2 container>
      <Grid2 xs={12}>
        {hasData ? (
          <Table
            tableData={tableData}
            faCols={RecommendedHeaderName}
            height="88vh"
            tableTitle={{
              title: "سهام پیشرو",
              desc: "مقیاس پول‌ها به میلیارد تومان می‌باشد",
            }}
            Form={RecommendedForm}
          />
        ) : (
          <RecommendedAddSetting />
        )}
      </Grid2>
    </Grid2>
  );
};

export default Recommended;
